import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="Y" transform="translate(20.000000, 20.000000)">
        <path
          d="M 42.2258 15.2 L 33 35 L 33 45 L 27 45 L 27 35 L 17.7343 15.2 L 25.0582 15.2 L 29 27 C 29 27 29.355 27.959 30 29 L 30 29 C 30.667 27.925 31 27 31 27 L 35.4718 15.2 L 42.2258 15.2 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
